import React, { useRef, useState, useEffect } from 'react';
import { siteData } from '../data/mockData';

const BannerSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative overflow-hidden"
      style={{ background: '#0a0a0a' }}
    >
      <div
        className="relative w-full"
        style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'scale(1)' : 'scale(1.02)',
          transition: 'all 1.2s cubic-bezier(0.16, 1, 0.3, 1)',
        }}
      >
        <img
          src={siteData.hero.bannerImage}
          alt="Cobras Architecture"
          className="w-full object-cover"
          style={{ maxHeight: '70vh', minHeight: '300px' }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a] via-transparent to-[#0a0a0a] opacity-30" />
      </div>
    </section>
  );
};

export default BannerSection;
